module.exports = __webpack_public_path__ + "r-v3/img/ico_play_white.cec88b91.svg";